import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";
import React from "react";

import number_one from "../../assets/images/number1.png";
import number_three from "../../assets/images/number3.png";
import number_two from "../../assets/images/number2.png";
import ContainedButton from "../../components/Buttons/ContainedButton";
import {SHOPIFY_URL} from "../../utils/shopify.utils";

const BuildYourBedColumn1 = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <div className="evrbase-col-3">
      <ContainedButton
        className="col-auto pull-right mobile-only"
        styles={{
          marginTop: "0.5rem",
          position: "relative",
          right: "-1rem"
        }}
        onClick={() => {
          return (window.top.location.href =
            SHOPIFY_URL + "pages/mattress-builder");
        }}
      >
        {t("START BUILDING")}
      </ContainedButton>
      <div className="evrbase-col-6 m-2">
        <div
          className="evrbase-note-one-title"
          style={{
            color: theme.COLORS.BLUE.darkBlueGreen,
          }}
        >
          {t("Tell Us About You")}
        </div>
        <div
          className="evrbase-note-one-text"
          style={{
            width: "105%",
            color: theme.COLORS.BLUE.darkBlueGreen,
            marginTop: "2vh",
            fontSize: "16",
            fontFamily: "noto-sans",
          }}
        >
          {t(
            "Five minutes is all it takes for a better sleep. Give us five minutes of your time to answer a few short questions so we can get to know you better."
          )}
        </div>
        <div className="evrbase-note-one-number-wrapper">
          <img
            className="mx-auto evrbase-note-one-number"
            src={number_one}
          ></img>
        </div>
        <div
          className="evrbase-note-two-title"
          style={{
            color: theme.COLORS.BLUE.darkBlueGreen,
          }}
        >
          {t("We Do The Math")}
        </div>
        <div
          style={{
            width: "100%",
            color: theme.COLORS.BLUE.darkBlueGreen,
            marginTop: "2vh",
            fontSize: "16",
            fontFamily: "noto-sans",
          }}
        >
          {t(
            "We take your inputs and calculate the best combination of components for you."
          )}
        </div>
        <div className="evrbase-note-two-number-wrapper">
          <img
            className="mx-auto evrbase-note-two-number"
            src={number_two}
          ></img>
        </div>
        <div
          className="evrbase-note-three-title"
          style={{
            color: theme.COLORS.BLUE.darkBlueGreen,
          }}
        >
          {t("You Sleep Better")}
        </div>
        <div
          style={{
            width: "100%",
            color: theme.COLORS.BLUE.darkBlueGreen,
            fontSize: "16",
            fontFamily: "noto-sans",
          }}
        >
          {t(
            "Utilizing 45 years of industry, we promise you'll have the best sleep of your life."
          )}
        </div>
        <div
          className="evrbase-note-three-number-wrapper"
        >
          <img
            className="mx-auto evrbase-note-three-number"
            src={number_three}
          ></img>
        </div>
      </div>
      <div
        className="mobile-only"
        style={{
          position: "fixed",
          bottom: "7rem",
          width: "100%"
        }}
      >
        <ContainedButton
          className="evrbase-footer-button-1"
          color={theme.COLORS.BLUE.backgroundBlue}
          fontColor={theme.COLORS.BLUE.blueGreen}
          variant="outlined"
          onClick={() =>
            (window.top.location.href = SHOPIFY_URL + "products/evrbed")
          }
        >
          {t("VIEW EVRBASE DETAILS")}
        </ContainedButton>
        <ContainedButton
          className="evrbase-footer-button-2"
          onClick={() => {
            return (window.top.location.href =
              SHOPIFY_URL + "pages/mattress-builder");
          }}
        >
          {t("START BUILDING")}
        </ContainedButton>
      </div>
    </div>

  );
};

export default BuildYourBedColumn1;
